import { render, staticRenderFns } from "./SimpleDatePicker.vue?vue&type=template&id=6766e4ac"
import script from "./SimpleDatePicker.vue?vue&type=script&lang=js"
export * from "./SimpleDatePicker.vue?vue&type=script&lang=js"
import style0 from "./SimpleDatePicker.vue?vue&type=style&index=0&id=6766e4ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VTextField})
